import apolloClient from 'api/apolloClient';
import { GENERATE_MAINTENANCE } from 'api/queries/biReportService';
import { FileType } from 'types/biReportService';

export async function generateMaintenance(type: FileType, recipients: string[]): Promise<boolean> {
  return (
    await apolloClient.mutate<{ generateMaintenance: boolean }>({
      mutation: GENERATE_MAINTENANCE,
      fetchPolicy: 'no-cache',
      variables: { type, recipients },
    })
  ).data!.generateMaintenance;
}
